import type { ScrollAxis } from "./scroll-box-axes"
import type { ContentUnit } from "./scroll-box-content"
import { largerMiddleMedian } from "./scroll-box-median"

const SAME_EDGE_TOLERANCE_PX = 1
const FIT_TOLERANCE_PX = 0.5

function startsNewLine(units: readonly ContentUnit[], index: number): boolean {
  return index === 0 || Math.abs(units[index].startPx - units[index - 1].startPx) > SAME_EDGE_TOLERANCE_PX
}

function sharesRowWith(unit: ContentUnit, firstUnit: ContentUnit): boolean {
  return (
    unit.crossStartPx < firstUnit.crossEndPx - SAME_EDGE_TOLERANCE_PX &&
    unit.crossEndPx > firstUnit.crossStartPx + SAME_EDGE_TOLERANCE_PX
  )
}

function leavesFirstRow(unit: ContentUnit, firstUnit: ContentUnit, axis: ScrollAxis): boolean {
  return axis.name === "horizontal" && !sharesRowWith(unit, firstUnit)
}

function countWholeUnitsFrom(
  units: readonly ContentUnit[],
  firstIndex: number,
  axis: ScrollAxis,
  effectivePx: number,
): number {
  const firstUnit = units[firstIndex]
  let wholeUnits = 0
  for (const unit of units.slice(firstIndex)) {
    if (leavesFirstRow(unit, firstUnit, axis)) break
    if (unit.endPx - firstUnit.startPx > effectivePx + FIT_TOLERANCE_PX) break
    wholeUnits++
  }
  return wholeUnits
}

export function countWholeUnitsThatFit(units: readonly ContentUnit[], axis: ScrollAxis, effectivePx: number): number {
  const countsFromEachLineStart: number[] = []
  units.forEach((_, index) => {
    if (!startsNewLine(units, index)) return
    const wholeUnits = countWholeUnitsFrom(units, index, axis, effectivePx)
    if (wholeUnits === units.length - index) return
    countsFromEachLineStart.push(wholeUnits)
  })
  return countsFromEachLineStart.length === 0 ? units.length : largerMiddleMedian(countsFromEachLineStart)
}
